<template>
    <div>
        <div class="row">
            <div class="col-md-12 mb-50">
                <label class="form-label">Referans Model</label>
                <v-select-list multiple :options="c_referenceModels" label="VehicleReferenceModelManuelName" v-model="referenceModel" placeholder="Referans Model"></v-select-list>
            </div>
            <div class="col-md-12 mb-1">
                <b-form-checkbox v-model="rememberReferenceModel" inline>Referans Modeli Hatırla</b-form-checkbox>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-12 mb-1">
                        <label class="form-label">Başlangıç İli</label>
                        <v-select-list v-model="startProvince" :options="provinces" label="Name" v-on:input="getDistricts(true)" placeholder="Başlangıç İli"></v-select-list>
                    </div>
                    <div class="col-12 mb-1">
                        <label class="form-label">Başlangıç İlçesi</label>
                        <v-select-list :disabled="!startProvince" v-model="startDistrict" :options="startDistricts" label="Name" placeholder="Başlangıç İlçesi"></v-select-list>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-12 mb-1">
                        <label class="form-label">Varış İli</label>
                        <v-select-list v-model="endProvince" :options="provinces" label="Name" v-on:input="getDistricts(false)" placeholder="Varış İli"></v-select-list>
                    </div>
                    <div class="col-12 mb-1">
                        <label class="form-label">Varış İlçesi</label>
                        <v-select-list :disabled="!endProvince" v-model="endDistrict" :options="endDistricts" label="Name" placeholder="Varış İlçesi"></v-select-list>
                    </div>
                </div>
            </div>
            <div class="col-md-6 mb-1">
                <label class="form-label">Sefer Sayısı</label>
                <input type="number" v-model="countOfTrips" class="form-control" placeholder="Sefer Sayısı"/>
            </div>
            <!-- <div class="col-md-6 mb-1">
                <label class="form-label">Çalışılan Gün Sayısı</label>
                <input type="number" v-model="countOfDaysWorked" class="form-control" placeholder="Çalışılan Gün Sayısı"/>
            </div> -->
            <div class="col-md-6 mb-1">
                <label class="form-label">Müşteri Mesafe</label>
                <input type="number" class="form-control" v-model="customerKm" />
            </div>
            <div class="col-md-12 mb-1">
                <b-form-checkbox v-model="isAvoidTolls" inline>Paralı Yolları Dahil Et</b-form-checkbox>
                <b-form-checkbox v-model="isAvoidHighways" inline>Anayolları Dahil Et</b-form-checkbox>
            </div>
            <div class="col-md-12">
                <v-executer :disabled="c_disabledCalculate" full-width variant="success" :loading="calculating" text="Hesapla ve Ekle" :action="calculateDistance"></v-executer>
            </div>
        </div>
    </div>
</template>

<script>
import CalculatePriceApi from '@/api/calculate-price'
import SystemDataApi from '@/api/system-data'
import {BFormCheckbox} from 'bootstrap-vue'
import randomatic from 'randomatic'

export default {
    props:{
        value:Object,
        oneDayKm:Number,
    },
    components:{
        BFormCheckbox,
    },
    data() {
        return {
            calculating:false,
            referenceModels: [],
            referenceModel: [],
            provinces:[],
            startProvince:null,
            endProvince:null,
            startDistricts:[],
            endDistricts:[],
            startDistrict:null,
            endDistrict:null,
            customerKm:0,
            isAvoidTolls:false,
            isAvoidHighways:false,
            rememberReferenceModel:false,
            countOfTrips:1,
            countOfDaysWorked:1,
        }
    },
    watch:{
        startProvince(){
            this.startDistrict = null
        },
        endProvince(){
            this.endDistrict = null
        },
    },
    mounted(){
        this.getReferenceModels()
        this.getProvince()
    },
    methods:{
        clearForm(){
            this.startProvince = null
            this.endProvince = null
            this.startDistrict = null
            this.endDistrict = null
            this.customerKm = 0 
            this.isAvoidTolls = false
            this.isAvoidHighways = false
            this.countOfTrips = 1
            this.countOfDaysWorked = 1
            if(!this.rememberReferenceModel){
                this.referenceModel = []
            }
        },
        calculateDistance(){
            if(this.startProvince && this.endProvince && this.startDistrict && this.endDistrict){
                this.calculating = true
                CalculatePriceApi.DraftPrice.CalculateDistance({
                    StartProvinceId:this.startProvince.Id,
                    StartProvinceName:this.startProvince.Name,
                    StartDistrictId:this.startDistrict.Id,
                    StartDistrictName:this.startDistrict.Name,
                    EndProvinceId:this.endProvince.Id,
                    EndProvinceName:this.endProvince.Name,
                    EndDistrictId:this.endDistrict.Id,
                    EndDistrictName:this.endDistrict.Name,
                    Tolls:this.isAvoidTolls,
                    Highways:this.isAvoidHighways,
                    CustomerKm:this.customerKm,
                    CountOfTrips: this.countOfTrips
                }).then(res=>{
                    this.calculating = false
                    if(res.data.Success){
                        this.referenceModel.forEach(rm => {
                            let route = this.uncalculatedData(res.data.Data,'Manual',rm,this.oneDayKm)
                            this.value.UncalculatedRoutes.push(route)
                        })
                        this.clearForm()
                    }
                }).catch(err=>{
                    this.calculating = false
                    this.$result(null,err)
                })
            }
        },
        uncalculatedData(data,type,rm,oneDayKm){
            return {
                id:randomatic("A0",10),
                selected:false,
                startProvince: data.StartProvinceId ? { Id:data.StartProvinceId, Name:data.StartProvinceName } : null,
                startDistrict: data.StartDistrictId ? { Id:data.StartDistrictId, Name:data.StartDistrictName } : null,
                startNeighborhood: data.StartNeighborhoodId ? { Id:data.StartNeighborhoodId, Name:data.StartNeighborhoodName } : null,
                endProvince: data.EndProvinceId ? { Id:data.EndProvinceId, Name:data.EndProvinceName } : null,
                endDistrict: data.EndDistrictId ? { Id:data.EndDistrictId, Name:data.EndDistrictName } : null,
                endNeighborhood: data.EndNeighborhoodId ? { Id:data.EndNeighborhoodId, Name:data.EndNeighborhoodName } : null,
                isAvoidTolls:data.Tolls,
                isAvoidHighways:data.Highways,
                referenceModel:rm,
                countOfTrips:data.CountOfTrips,
                customerKm:data.CustomerKm,
                countOfDaysWorked:Math.ceil(data.Distance/oneDayKm),
                type:type,
                calculatedDistance: data.Distance
            }
        },
        getReferenceModels(){
            CalculatePriceApi.ReferenceModel.List()
            .then(res=>{
                this.referenceModels = res.data.Data
            })
        },
        getProvince(){
            SystemDataApi.ProvinceByCountry('43776974-AB91-4FA2-B2AC-87B5E8939241')
            .then((res) => {
                this.provinces = res.data.Data
            })
        },
        getDistricts(bool){
            if(this.startProvince?.Id || this.endProvince?.Id){
                let id = bool ? this.startProvince?.Id : this.endProvince?.Id
                if(id){
                    SystemDataApi.District(id)
                    .then((res) => {
                        if(bool) this.startDistricts = res.data.Data
                        else this.endDistricts = res.data.Data
                    })
                }
            }
        },
    },
    computed:{
        c_disabledCalculate(){
            if(this.referenceModel.length > 0 && this.startProvince && this.endProvince && this.startDistrict && this.endDistrict) return false
            else return true
        },
        c_referenceModels(){
            if(this.referenceModel.length > 0){
                const first = this.referenceModel[0]
                return this.referenceModels.filter(rm => rm.GroupNumber == first.GroupNumber)
            }else return this.referenceModels
        }
    }
}
</script>

<style>

</style>